import { getApiBaseUrl } from './apiBase';
const API_BASE_URL = getApiBaseUrl();

export const promoService = {
  async listActive() {
    const res = await fetch(`${API_BASE_URL}/promos/active`);
    const data = await res.json();
    if (!res.ok) throw new Error(data.msg || 'Failed to fetch active promos');
    return data.promos || [];
  },
  async list() {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No authentication token found');
    const res = await fetch(`${API_BASE_URL}/promos`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.msg || 'Failed to list promos');
    return data.promos || [];
  },
  async create(payload) {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No authentication token found');
    const res = await fetch(`${API_BASE_URL}/promos`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.msg || 'Failed to create promo');
    return data.promo;
  },
  async update(id, updates) {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No authentication token found');
    const res = await fetch(`${API_BASE_URL}/promos/${encodeURIComponent(id)}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updates)
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.msg || 'Failed to update promo');
    return data.promo;
  },
  async remove(id) {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No authentication token found');
    const res = await fetch(`${API_BASE_URL}/promos/${encodeURIComponent(id)}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.msg || 'Failed to delete promo');
    return data;
  }
};